import { useState } from "react";
import { stepItems } from "./utils";
import RightArrow from "@/public/icons/hiw-right-arrow.svg";
import TimeClock from "@/public/icons/clock-orange-circle.svg";
import Step5Image from "@/public/icons/hiw-step5.svg";
import ExpandableBox from "@/components/landing-old/ExpandableBox";
import { scroller } from "react-scroll";

const Step5 = (): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const clickHandler = (idx: number) => {
    setActiveIndex((current) => (current === idx ? -1 : idx));
  };
  const scrollToCalculator = () => {
    scroller.scrollTo("calculator", { smooth: true, duration: 50, offset: -180 });
  };
  return (
    <section className="relative bg-white w-full px-4 md:px-5 lg:px-20 lg:py-16">
      <div className="h-20 lg:h-0"></div>
      <h2 className="text-landing-orange font-bold text-2xl lg:text-3xl mb-3 lg:mb-5">Step 5</h2>
      <div className="flex flex-col lg:flex-row items-center lg:items-start">
        <div className="flex flex-col lg:w-1/2">
          <h3 className="text-4xl lg:text-5xl font-bold text-landing-blue mb-5 md:mb-3 lg:mb-5">
            Buy the home when you’re ready
          </h3>
          <div className="flex flex-col md:flex-row lg:flex-col items-center">
            <div className="w-full md:w-1/2 lg:w-full">
              <h4 className="font-serif text-xl lg:text-3xl text-landing-blue mb-5">
                When it&apos;s time to buy, or if you decide to walk away, Keyzy is here to help you
                every step of the way.
              </h4>
              <p className="font-base mb-5">
                You can buy the home from Keyzy using the rent you&apos;ve already paid as your
                deposit.
              </p>
              <p className="font-base mb-4 md:mb-12 lg:mb-9">
                If you don&apos;t want to buy the home you can walk away with no penalties, just
                like any other rental that you choose to leave.
              </p>
            </div>
            <div className="w-full md:w-1/2 lg:w-full hidden md:flex lg:hidden justify-around">
              <Step5Image width={"90%"} height={"100%"} />
            </div>
          </div>
          <div className="flex flex-row justify-between mb-0 md:mb-6 lg:mb-9">
            <button onClick={scrollToCalculator}>
              <a className="relative flex items-center">
                <span className={`relative text-base font-bold text-landing-orange`}>
                  Calculate your budget
                </span>
                <RightArrow className="md:ml-3 ml-1" />
              </a>
            </button>
            <div className="flex flex-row justify-between items-center">
              <TimeClock className="mr-3" />
              <span className={`inline-block relative text-base text-landing-orange`}>2 years</span>
            </div>
          </div>

          <div className="md:hidden w-full my-5 flex justify-around">
            <Step5Image width={"80%"} height={"100%"} />
          </div>
          <div className="relative z-30 w-full">
            {stepItems.map((faq, idx) => (
              <div key={idx}>
                <ExpandableBox
                  question={faq.question}
                  answer={faq.answer}
                  active={activeIndex === idx}
                  clickHandler={() => clickHandler(idx)}
                  page={"hiw"}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="hidden lg:flex lg:justify-around items-center lg:w-1/2">
          <Step5Image width={"80%"} height={"100%"} />
        </div>
      </div>
    </section>
  );
};

export default Step5;
